var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFields(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 2.23999H26.88",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 6.71997H14.56",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 6.71997H22.4",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.16 20.16V38.08",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79358 53.76C5.70078 53.144 6.61914 52.528 7.54874 51.9456C9.57594 50.6576 11.6704 49.448 13.8096 48.328C15.9488 47.208 18.1775 46.088 20.4287 45.1808C22.6799 44.2736 25.0543 43.3328 27.4399 42.5488C36.2953 39.6267 45.555 38.1149 54.8799 38.0688",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2496 53.76C25.931 46.5054 40.2705 42.6476 54.88 42.56",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.24 53.76C33.2177 49.3848 43.9853 47.0979 54.88 47.04",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8801 51.52C48.872 51.5498 42.8894 52.3018 37.0609 53.76",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 8.95999C52.2557 8.95999 53.76 7.45567 53.76 5.59999C53.76 3.74431 52.2557 2.23999 50.4 2.23999C48.5444 2.23999 47.04 3.74431 47.04 5.59999C47.04 7.45567 48.5444 8.95999 50.4 8.95999Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 38.08H54.88",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 42.56H27.3504",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12 47.04H16.2848",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7601 20.16C53.7601 18.6748 53.17 17.2504 52.1198 16.2002C51.0696 15.15 49.6453 14.56 48.1601 14.56C46.6748 14.56 45.2505 15.15 44.2003 16.2002C43.1501 17.2504 42.5601 18.6748 42.5601 20.16V28C42.5601 29.4852 43.1501 30.9096 44.2003 31.9598C45.2505 33.01 46.6748 33.6 48.1601 33.6C49.6453 33.6 51.0696 33.01 52.1198 31.9598C53.17 30.9096 53.7601 29.4852 53.7601 28V20.16Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.28 33.6V38.08",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3199 23.52V38.08",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.08 26.88V38.08",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5601 21.8848C41.334 20.7714 39.7362 20.1562 38.0801 20.16C36.936 20.1586 35.8105 20.4493 34.8103 21.0045C33.81 21.5598 32.9681 22.3612 32.3643 23.3329C31.7604 24.3045 31.4146 25.4143 31.3596 26.557C31.3046 27.6997 31.5423 28.8376 32.0501 29.8627C32.5579 30.8879 33.319 31.7664 34.2613 32.4152C35.2036 33.0639 36.2959 33.4613 37.4348 33.5697C38.5737 33.6782 39.7214 33.4941 40.7692 33.0348C41.8171 32.5756 42.7303 31.8565 43.4225 30.9456",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.32 33.6C17.887 33.6 22.4 29.087 22.4 23.52C22.4 17.953 17.887 13.44 12.32 13.44C6.75296 13.44 2.23999 17.953 2.23999 23.52C2.23999 29.087 6.75296 33.6 12.32 33.6Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5278 32.1328C18.3304 32.8572 19.3255 33.3337 20.3929 33.5049C21.4604 33.6762 22.5545 33.5348 23.5434 33.0978C24.5322 32.6608 25.3735 31.9469 25.9655 31.0423C26.5575 30.1377 26.8751 29.0811 26.8798 28V21.28C26.8797 20.3595 26.6526 19.4532 26.2187 18.6414C25.7848 17.8296 25.1576 17.1372 24.3923 16.6256C23.6271 16.114 22.7476 15.7989 21.8315 15.7082C20.9155 15.6175 19.9913 15.754 19.1406 16.1056",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFields);
export default __webpack_public_path__ + "static/media/fields.0d2eb34e69f903ec457d2cf891d85d69.svg";
export { ForwardRef as ReactComponent };